import { render, staticRenderFns } from "./user-center-weal.vue?vue&type=template&id=ebd11b8c&scoped=true"
import script from "./user-center-weal.vue?vue&type=script&lang=js"
export * from "./user-center-weal.vue?vue&type=script&lang=js"
import style0 from "./user-center-weal.vue?vue&type=style&index=0&id=ebd11b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd11b8c",
  null
  
)

export default component.exports